import { FC } from 'react';
import Chip from './';
import { ChipColor, ChipSize } from './helpers';
import { McpToolClassificationAction } from '@/lib/models/mcp-tool';

interface Props {
  value: McpToolClassificationAction;
  size?: ChipSize;
}

const ColorMap: Map<McpToolClassificationAction, ChipColor> = new Map();
ColorMap.set(McpToolClassificationAction.READ, 'success');
ColorMap.set(McpToolClassificationAction.WRITE, 'warning');

const LabelMap: Map<McpToolClassificationAction, string> = new Map();
LabelMap.set(McpToolClassificationAction.READ, 'READ');
LabelMap.set(McpToolClassificationAction.WRITE, 'WRITE');

const ClassificationActionChip: FC<Props> = ({ value, size = 'medium' }) => {
  return (
    <Chip
      label={LabelMap.get(value) || 'UNKNOWN'}
      color={ColorMap.get(value) || 'default'}
      size={size}
    />
  );
};

export default ClassificationActionChip;
